import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductsComponent } from './products.component';
import { ProductIndexComponent } from './product-index/product-index.component';
import { ProductEditComponent } from './product-edit/product-edit.component';
import { ProductCreateComponent } from './product-create/product-create.component';
import { ProductFormComponent } from './product-form/product-form.component';
import {CardModule} from '../../resources/components/card/card.module';
import {ProductsRoutesModule} from './products-routes/products-routes.module';
import {FormGroupContextModule} from '../../resources/modules/form-group-context/form-group-context.module';
import {FormGroupSimpleModule} from '../../resources/modules/form-group-context/form-group-simple/form-group-simple.module';
import {ValidateModule} from '../../resources/modules/validate/validate.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TableProductModule} from '../../resources/tables/table-product/table-product.module';
import {FormGroupSelectModule} from '../../resources/modules/form-group-context/form-group-select/form-group-select.module';
import { ProductViewComponent } from './product-view/product-view.component';
import { ProductViewInfoComponent } from './product-view/product-view-info/product-view-info.component';
import { ProductViewPurchasesComponent } from './product-view/product-view-purchases/product-view-purchases.component';
import {TablePurchaseModule} from '../../resources/tables/table-purchase/table-purchase.module';
import {BadgeExistModule} from '../../resources/components/badge-exist/badge-exist.module';
import {EntityLinkModule} from "../../resources/components/entity-link/entity-link.module";
import {UpperFirstPipeModule} from "../../resources/pipes/upper-first-pipe/upper-first-pipe.module";
import {SharedModule} from "../../modules/shared.module";
import {BtnDeleteModule} from "../../resources/components/btn-delete/btn-delete.module";
import {RouterOuterDirectiveModule} from "../../resources/directives/router-outer-directive/router-outer-directive.module";
import {TabsRouteModule} from "../../resources/components/tabs-route/tabs-route.module";



@NgModule({
  declarations: [
    ProductsComponent,
    ProductIndexComponent,
    ProductEditComponent,
    ProductCreateComponent,
    ProductFormComponent,
    ProductViewComponent,
    ProductViewInfoComponent,
    ProductViewPurchasesComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    ProductsRoutesModule,
    FormGroupContextModule,
    FormGroupSimpleModule,
    ValidateModule,
    FormsModule,
    ReactiveFormsModule,
    TableProductModule,
    FormGroupSelectModule,
    TablePurchaseModule,
    BadgeExistModule,
    EntityLinkModule,
    UpperFirstPipeModule,
    SharedModule,
    BtnDeleteModule,
    RouterOuterDirectiveModule,
    TabsRouteModule
  ]
})
export class ProductsModule { }
